import type { MouseEventHandler } from "react";
import { Button } from "@mantine/core";
import type { ButtonProps } from "@mantine/core";
import ArrowRightIcon from "../../assets/arrow-right-icon.svg";

interface AppWebviewButtonProps extends ButtonProps {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** White card-style row: smaller, label wraps to the left, arrow pinned right. */
  card?: boolean;
}

const CARD_PROPS: ButtonProps = {
  variant: "default",
  size: "sm",
  h: "auto",
  p: "sm",
  justify: "space-between",
  styles: {
    root: { border: "none" },
    label: { textAlign: "left", overflow: "visible" },
  },
};

export function AppWebviewButton({
  rightSection,
  children,
  loading,
  disabled,
  card,
  ...props
}: AppWebviewButtonProps) {
  return (
    <Button
      {...(card && CARD_PROPS)}
      {...props}
      loading={loading}
      disabled={disabled}
      fullWidth
      rightSection={rightSection ?? <ArrowRightIcon aria-hidden="true" />}
    >
      {children}
    </Button>
  );
}
